import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["x", "y", "href"]
const _hoisted_3 = ["x", "y", "href"]
const _hoisted_4 = { key: 0 }

import {VueBarGraph} from 'vue-bar-graph';
import {computed, onMounted, ref} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RepoActivityTopAuthors',
  setup(__props) {

const colors = ref({
  barColor: 'green',
  textColor: 'black',
  textAltColor: 'white',
});

// possible keys:
// * avatar_link: (...)
// * commits: (...)
// * home_link: (...)
// * login: (...)
// * name: (...)
const activityTopAuthors = window.config.pageData.repoActivityTopAuthors || [];

const graphPoints = computed(() => {
  return activityTopAuthors.map((item) => {
    return {
      value: item.commits,
      label: item.name,
    };
  });
});

const graphAuthors = computed(() => {
  return activityTopAuthors.map((item, idx) => {
    return {
      position: idx + 1,
      ...item,
    };
  });
});

const graphWidth = computed(() => {
  return activityTopAuthors.length * 40;
});

const styleElement = ref<HTMLElement | null>(null);
const altStyleElement = ref<HTMLElement | null>(null);

onMounted(() => {
  const refStyle = window.getComputedStyle(styleElement.value);
  const refAltStyle = window.getComputedStyle(altStyleElement.value);

  colors.value = {
    barColor: refStyle.backgroundColor,
    textColor: refStyle.color,
    textAltColor: refAltStyle.color,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "activity-bar-graph",
      ref_key: "styleElement",
      ref: styleElement,
      style: {"width":"0","height":"0"}
    }, null, 512 /* NEED_PATCH */),
    _createElementVNode("div", {
      class: "activity-bar-graph-alt",
      ref_key: "altStyleElement",
      ref: altStyleElement,
      style: {"width":"0","height":"0"}
    }, null, 512 /* NEED_PATCH */),
    _createVNode(_unref(VueBarGraph), {
      points: graphPoints.value,
      "show-x-axis": true,
      "show-y-axis": false,
      "show-values": true,
      width: graphWidth.value,
      "bar-color": colors.value.barColor,
      "text-color": colors.value.textColor,
      "text-alt-color": colors.value.textAltColor,
      height: 100,
      "label-height": 20
    }, {
      label: _withCtx((opt) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(graphAuthors.value, (author, idx) => {
          return (_openBlock(), _createElementBlock("g", {
            key: author.position
          }, [
            (opt.bar.index === idx && author.home_link)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: author.home_link
                }, [
                  _createElementVNode("image", {
                    x: `${opt.bar.midPoint - 10}px`,
                    y: `${opt.bar.yLabel}px`,
                    height: "20",
                    width: "20",
                    href: author.avatar_link
                  }, null, 8 /* PROPS */, _hoisted_2)
                ], 8 /* PROPS */, _hoisted_1))
              : (opt.bar.index === idx)
                ? (_openBlock(), _createElementBlock("image", {
                    key: 1,
                    x: `${opt.bar.midPoint - 10}px`,
                    y: `${opt.bar.yLabel}px`,
                    height: "20",
                    width: "20",
                    href: author.avatar_link
                  }, null, 8 /* PROPS */, _hoisted_3))
                : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      title: _withCtx((opt) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(graphAuthors.value, (author, idx) => {
          return (_openBlock(), _createElementBlock("tspan", {
            key: author.position
          }, [
            (opt.bar.index === idx)
              ? (_openBlock(), _createElementBlock("tspan", _hoisted_4, _toDisplayString(author.name), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["points", "width", "bar-color", "text-color", "text-alt-color"])
  ]))
}
}

})